<template>
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10.9203 12.3697L15.6003 17.0497C15.8203 17.2697 15.9303 17.5497 15.9303 17.8897C15.9303 18.2297 15.8203 18.5097 15.6003 18.7297C15.3803 18.9497 15.1003 19.0597 14.7603 19.0597C14.4203 19.0597 14.1403 18.9497 13.9203 18.7297L8.40031 13.2097C8.28031 13.0897 8.19531 12.9597 8.14531 12.8197C8.09531 12.6797 8.07031 12.5297 8.07031 12.3697C8.07031 12.2097 8.09531 12.0597 8.14531 11.9197C8.19531 11.7797 8.28031 11.6497 8.40031 11.5297L13.9203 6.00969C14.1403 5.78969 14.4203 5.67969 14.7603 5.67969C15.1003 5.67969 15.3803 5.78969 15.6003 6.00969C15.8203 6.22969 15.9303 6.50969 15.9303 6.84969C15.9303 7.18969 15.8203 7.46969 15.6003 7.68969L10.9203 12.3697Z"
            fill="#272657" />
    </svg>
</template>
<script>
export default {
    name: "BackBtn",
    components: {},
};
</script>
<style lang="scss">
</style>